import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => ({
  outerContainer: {
    height: 'auto',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
  },

  dtlOriginalsContainer: {
    maxWidth: theme.maxWidth,
    padding: theme.spacing(0, 16),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0, 4),
    },
  },
}))

export default useStyles
